import React from 'react';
import UrlLink from '../../../components/UI/UrlLink/UrlLink';
import classes from './HandlingUserData.module.css';
import paths from '../../../constants/paths';

import { QUERY_PARAM_DELETE_ACCOUNT } from '../../../containers/ContactUs/ContactUsContainer';

const en = (props) => (
  <div className={classes.Content}>
    {props.indexPage ? (
      <div>
        <p style={{ marginBottom: props.indexPage ? '1rem' : 0 }}>
          {' '}
          <b> Lataa tiedot </b>{' '}
        </p>
        <p>
          {' '}
          Voit ladata tietosi seuraavalle sivulle <br />
          Asetukset {'>'} Asetukset {'>'} Tiedonhallinta {'>'} Lataa tiedot
        </p>{' '}
        <br />
        <div className={classes.HrLine} />
        <br />
      </div>
    ) : null}
    <p style={{ textAlign: props.indexPage ? 'left' : 'center' }}>
      {' '}
      <b> Pyydä tietojen poistamista </b>{' '}
    </p>{' '}
    <br />
    <p> Voit pyytää tietojen poistamista seuraavasti: </p> <br />
    <p>
      1. Siirry{' '}
      <UrlLink
        to={`${
          props.indexPage ? paths.CONTACT_US : paths.SETTINGS__CONTACT_US
        }?${QUERY_PARAM_DELETE_ACCOUNT}`}
      >
        Ota yhteyttä -sivulle
      </UrlLink>
      <br />
      2. Valitse vaihtoehto "Poista tili ja kaikki tietoni" <br />
      3. Täytä lomake ja paina "Lähetä viesti" <br /> <br />
    </p>
  </div>
);

export default en;
